import { axiosPrivate } from "@app/dashboard/tools/axios/axiosInstance";

export const getMerchantFlags = () => {
  return axiosPrivate.get(`/dashboard/api/v1/merchant/flags`);
};

export const updateMerchantFlags = (payload: Record<string, string | boolean | number>) => {
  return axiosPrivate.post('/dashboard/api/v1/merchant/flags', payload);
};